// NudgeContext.js
import React, { useReducer, useEffect } from 'react'
import { getStorage, setStorage } from 'utils/LocalStorage'
import { uuidv4 } from 'utils/Lists'
// import data from 'utils/sampleData'

export const nudgeTest = {
    user: {
        name: 'Test User',
    },
    problems: [
        {
            id: uuidv4(),
            name: 'What do I want to eat?',
            decisions: [
                { name: 'Chipotle', id: uuidv4() },
                { name: 'Five Guys', id: uuidv4() },
                { name: 'Piada', id: uuidv4() },
            ],
        },
        {
            id: uuidv4(),
            name: 'Where should we send it?',
            decisions: [
                { name: 'Kettering', id: uuidv4() },
                { name: 'Stubbs', id: uuidv4() },
                { name: 'Not Sycamore', id: uuidv4() },
                { name: 'Karol', id: uuidv4() },
            ],
        },
        {
            id: uuidv4(),
            name: 'What should I watch?',
            decisions: [
                { name: 'The Dark Knight', id: uuidv4() },
                { name: 'Dexter', id: uuidv4() },
                { name: 'Spiderman - Into The Spiderverse', id: uuidv4() },
                { name: 'Bugs Life', id: uuidv4() },
                { name: 'Inception', id: uuidv4() },
                { name: 'Suits', id: uuidv4() },
            ],
        },
        {
            id: uuidv4(),
            name: 'What should I do?',
            decisions: [
                { name: 'Sleep', id: uuidv4() },
                { name: 'Nothing', id: uuidv4() },
                { name: 'Sit there', id: uuidv4() },
                { name: 'Something', id: uuidv4() },
                { name: `What you're doing now`, id: uuidv4() },
                { name: 'Nothing', id: uuidv4() },
            ],
        },
    ],
}

export const nudgeEmpty = {
    user: {
        name: '',
    },
    problems: [],
}

export const nudge = nudgeEmpty

export const reducer = (info, newInfo) => {
    if (newInfo === null) {
        localStorage.removeItem('info')
        return nudge
    }
    return { ...info, ...newInfo }
}

const localState = getStorage()

const NudgeContext = React.createContext()

function NudgeProvider({ children }) {
    const [nudgeStore, setNudge] = useReducer(reducer, localState || nudge)

    useEffect(() => {
        setStorage('nudge', nudgeStore)
    }, [nudgeStore])

    return (
        <NudgeContext.Provider value={{ nudgeStore, setNudge }}>{children}</NudgeContext.Provider>
    )
}

export { NudgeContext, NudgeProvider }
